const getBankFeeDescription = (user, loading) =>
  user?.covers_ach_fee && !loading ? '$2 convenience fee' : 'Completely FREE';

export default getBankFeeDescription;
